import React, { useState } from 'react';
import {Table as TablaBoot, Button, input} from 'react-bootstrap';
import { Trash } from 'react-bootstrap-icons';

function ListadoDetalleCbp (props) {
  console.log(props.datos)

  if (props.datos.length >= 4) {
    //llego al máximo valor del listado
    props.setListaDetalleCompleta(true);
  } else {
    props.setListaDetalleCompleta(false);
  }

  return (
    <>
      <TablaBoot striped bordered hover >
        <thead>
          <tr>
            <th>
              Num_serie
            </th>
            <th>
              Largo
            </th>
            <th>
              Trizadura
            </th>
            <th>
              Quebradura
            </th>
            <th>
              Perforación
            </th>
            <th>
              Resultado
            </th>
            <th>
              Acción
            </th>
          </tr>
        </thead>
        <tbody>
          {props.datos.map((detalle) => 
            <tr>
              <td>{detalle.serie_epp}</td>
              <td>{detalle.largo}</td>
              <td>{detalle.trizadura}</td>
              <td>{detalle.quebradura}</td>
              <td>{detalle.perforacion}</td>
              <td>{detalle.resultado_visual}</td>
              <td> <button onClick={() => {props.borraElementoDetalle(detalle.serie_epp)}} class="btn btn-outline-primary" size="sm"><Trash /></button> </td>
            </tr>
            )}
        </tbody>
      </TablaBoot>
      <hr />
      <TablaBoot striped bordered hover >
        <thead>
          <tr>
            <th>
              Num_serie
            </th>
            <th>
              Tensión
            </th>
            <th>
              I. fuga
            </th>
            <th>
              Descarga Superficial
            </th>
            <th>
              Perforación durante ensayo
            </th>
            <th>
              Resultado
            </th>
          </tr>
        </thead>
        <tbody>
          {props.datos.map((detalle) => 
            <tr key={detalle.serie_epp} >
              <td>{detalle.serie_epp}</td>
              <td>{detalle.tension}</td>
              <td>{detalle.fuga1}</td>
              <td>{detalle.descarga_superficial}</td>
              <td>{detalle.perforacion_ensayo}</td>
              <td>{detalle.resultado_resistencia}</td>
            </tr>
            )}
        </tbody>
      </TablaBoot>
    </>
  )
}

export default ListadoDetalleCbp;